import { lazy, Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { useContactBarVisible, CONTACT_BAR_HEIGHT_CLASS } from './TopContactBar';
import { afterFirstPaint } from '@/api/base44Lazy';

// The "Before you go" popup can't appear for at least 8 seconds, so its code (dialog, form,
// pricing list) is downloaded only once the page has loaded and the phone is idle.
const ExitIntentPopup = lazy(() => import('./ExitIntentPopup'));

function useWhenIdle() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let cancelled = false;
    afterFirstPaint(() => {
      const go = () => { if (!cancelled) setReady(true); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 4000 });
      else setTimeout(go, 1500);
    });
    return () => { cancelled = true; };
  }, []);
  return ready;
}

export default function Layout() {
  const showContactBar = useContactBarVisible();
  const idle = useWhenIdle();
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Navbar />
      {/* Pushes every page down by the height of the fixed call/WhatsApp strip */}
      {showContactBar && <div className={`shrink-0 ${CONTACT_BAR_HEIGHT_CLASS}`} aria-hidden="true" />}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {idle && (
        <Suspense fallback={null}>
          <ExitIntentPopup />
        </Suspense>
      )}
    </div>
  );
}
